import { Get, Post } from "services";

export const searchMdmData = async (body) => {
  const res = await Get(`inventory/device/mdm`, body);
  return res;
};

export const searchMdmExport = async (body) => {
  const res = await Post(`inventory/device/mdm/report/export`, body);
  return res;
};
